import React from 'react';
 
const PaymentContext = React.createContext(null);
 
export default PaymentContext;
